import React from "react";
import PropTypes from "prop-types";

import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import { FlexDiv } from "@/components/Atoms/Box";
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

import { AnchorLink } from "./style";

function ContactDetails({ number, email, iconFill, iconSize, textColor }) {
  const contactDetails = [
    {
      link: `tel:${number}`,
      icon: "icon-whatsapp",
      content: number,
    },
    {
      link: `mailto:${email}`,
      icon: "icon-EnvelopeSimple",
      content: email,
    },
  ];

  return (
    <FlexDiv flexDirection="column" alignItems="flex-start">
      {contactDetails.map(
        (detail) =>
          detail.content && (
            <AnchorLink href={detail.link} key={detail.link}>
              <StyledSvgSprite
                icon={detail.icon}
                fill={"#25d366"}
                height={iconSize}
                width={iconSize}
                mr="16px"
              />
              <Typography variant="label2" color={textColor}>
                {detail.content}
              </Typography>
            </AnchorLink>
          )
      )}
    </FlexDiv>
  );
}

ContactDetails.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  email: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconFill: PropTypes.string,
  iconSize: PropTypes.string,
  textColor: PropTypes.string,
};

ContactDetails.defaultProps = {
  number: "",
  email: "",
  iconFill: theme.colorsV2.rose.shade_400,
  iconSize: "16px",
  textColor: theme.colorsV2.gray.shade_700,
};

export default ContactDetails;
